import React from 'react'
import { MAXIMUM_FRACTION_DIGITS_BY_CURRENCY, PRICE_LOCALE_BY_CURRENCY } from '../../mappings'

interface Props {
  currency: string
  amount: number
  options?: Intl.NumberFormatOptions
}

const FormattedPrice: React.FC<Props> = ({ currency, amount, options = {} }) => {
  return (
    <>
      {new Intl.NumberFormat(PRICE_LOCALE_BY_CURRENCY[currency.toUpperCase()] || 'en-US', {
        maximumFractionDigits: MAXIMUM_FRACTION_DIGITS_BY_CURRENCY[currency.toUpperCase()],
        ...options,
        style: 'currency',
        currency: currency.toUpperCase(),
        currencyDisplay: 'narrowSymbol',
      }).format(amount)}
    </>
  )
}

export default FormattedPrice
